import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import { fetchAllIndicatorGroup } from "../data/redux/performance/indicatorgroup/indicatorgroupAction";
import { fetchAllIndicator } from "../data/redux/performance/indicator/indicatorAction";
import { fetchAllDesignations } from "../data/redux/designation/designationAction";
import Select from "react-select";
import { createRoleIndicator, fetchAllRoleindicator } from "../data/redux/performance/roleindicator/roleindicatorAction";
import { fetchAllKRA } from "../data/redux/performance/KRA/kraAction";
import { SelectOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import { message } from "antd";


interface PerformanceIndicatorModalProps {
  open: boolean;
  onClose: () => void;
}

const PerformanceIndicatorModal: React.FC<PerformanceIndicatorModalProps> = ({
  open,
  onClose,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: any) => state.auth);
  const [errors, setErrors] = useState<any>({});
  const { indicatorgroup } = useSelector((state: any) => state.performance.indicatorgroup);
  const { indicator } = useSelector((state: any) => state.performance.indicator);
  const { roleindicator, loadingStates } = useSelector((state: any) => state.performance.roleindicator);
  const isLoading = loadingStates.create;
  const { designations } = useSelector((state: any) => state.designation);
  const { kra } = useSelector((state: any) => state.performance.kra);

  useEffect(() => {
    dispatch(fetchAllIndicatorGroup());
    dispatch(fetchAllIndicator());
    dispatch(fetchAllDesignations());
    dispatch(fetchAllKRA());
  }, [dispatch]);

  const status = [
    { value: "Select", label: "Select" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const [selectedKRA, setSelectedKRA] = useState<any>(null);

  const formattedDegination = designations.map((emp: any) => ({
    value: emp.DesignationId,
    label: emp.DesignationName,
  }));

  const formattedIndicatorGroup = indicatorgroup.map((group: any) => ({
    value: group.Id,
    label: group.Name,
  }));
  const formattedindicator = indicator.map((group: any) => ({
    value: group.Id,
    label: group.Name,
  }));
  const formattedKRA = kra.map((emp: any) => ({
    value: emp.id,
    label: emp.Name,
    fullData: emp,
  }));

  const [formData, setFormData] = useState<any>({
    role_name: "",
    selectedRole: formattedDegination[0] || {
      value: "Select",
      label: "Select",
    },
    groups: [],
    status: status[0],
    createdBy: user.UserId
  });

  const StarRating = ({
    rating,
    onRate,
  }: {
    rating: number;
    onRate: (rating: number) => void;
  }) => {
    const handleClick = (star: number, isHalf: boolean) => {
      const newRating = isHalf ? star - 0.5 : star;
      onRate(newRating);
    };

    return (
      <div style={{ display: "flex", gap: "4px" }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <div
            key={star}
            style={{
              position: "relative",
              fontSize: "24px",
              cursor: "pointer",
            }}
          >
            <span
              style={{
                position: "absolute",
                width: "50%",
                overflow: "hidden",
                color: rating >= star - 0.5 ? "gold" : "gray",
              }}
              onClick={() => handleClick(star, true)}
            >
              ★
            </span>

            <span
              style={{
                color: rating >= star ? "gold" : "gray",
              }}
              onClick={() => handleClick(star, false)}
            >
              ★
            </span>
          </div>
        ))}
      </div>
    );
  };

  const handleRoleChange = (selectedOption: any) => {
    setFormData((prevState: any) => ({
      ...prevState,
      selectedRole: selectedOption.value,
    }));
  };

  const handleStatusChange = (selectedOption: any) => {
    setFormData((prevState: any) => ({
      ...prevState,
      status: selectedOption.value,
    }));
  };

  const handleWeightageChange = (e: any, groupId: number) => {
    setFormData((prevState: any) => {
      const updatedGroups = prevState.groups.map((group: any) =>
        group.id === groupId ? { ...group, weightage: e.target.value } : group
      );
      return { ...prevState, groups: updatedGroups };
    });
  };

  const handleRemoveGroup = () => {
    setFormData((prevState: any) => {
      if (prevState.groups.length === 0) return prevState;

      return {
        ...prevState,
        groups: prevState.groups.slice(0, -1),
      };
    });
  };

  const handleRatingChange = (
    newRating: number,
    groupId: number,
    index: number
  ) => {
    setFormData((prev: any) => {
      const updatedGroups = prev.groups.map((group: any) => {
        if (group.id === groupId) {
          const updatedIndicators = [...group.indicators];

          if (updatedIndicators[index]) {
            updatedIndicators[index] = {
              ...updatedIndicators[index],
              rating: newRating,
            };
          }

          return { ...group, indicators: updatedIndicators };
        }
        return group;
      });

      return { ...prev, groups: updatedGroups };
    });
  };

  const handleAddGroup = () => {
    setFormData((prevState: any) => ({
      ...prevState,
      groups: [
        ...prevState.groups,
        {
          id: Date.now(),
          serial_no: prevState.groups.length + 1,
          selectedGroup: null,
          indicators: [],
          weightage: "",
        },
      ],
    }));
  };

  const handleGroupChange = (selectedOption: any, groupId: number) => {
    setFormData((prevState: any) => {
      const updatedGroups = prevState.groups.map((group: any) =>
        group.id === groupId
          ? { ...group, selectedGroup: selectedOption }
          : group
      );
      return { ...prevState, groups: updatedGroups };
    });
  };

  const handleAddIndicatorRow = (groupId: number) => {
    setFormData((prevState: any) => {
      const updatedGroups = prevState.groups.map((group: any) =>
        group.id === groupId
          ? {
            ...group,
            indicators: [
              ...group.indicators,
              {
                id: group.indicators.length + 1,
                indicator: "",
                rating: "",
                weightage: "",
              },
            ],
          }
          : group
      );
      return { ...prevState, groups: updatedGroups };
    });
  };

  const handleInputChange = (
    e: any,
    groupId: number,
    index: number,
    isSelect = false,
    fieldName = ""
  ) => {
    setFormData((prevState: any) => {
      const updatedGroups = prevState.groups.map((group: any) => {
        if (group.id === groupId) {
          const updatedIndicators = [...group.indicators];

          if (isSelect) {
            updatedIndicators[index][fieldName] = e.value;
          } else {
            const { name, value } = e.target;
            updatedIndicators[index][name] = value;
          }

          return { ...group, indicators: updatedIndicators };
        }
        return group;
      });

      return { ...prevState, groups: updatedGroups };
    });
  };

  const handleRemoveIndicatorRow = (groupId: number, indicatorId: number) => {
    setFormData((prevState: any) => {
      const updatedGroups = prevState.groups.map((group: any) => {
        if (group.id === groupId) {
          return {
            ...group,
            indicators: group.indicators.filter(
              (ind: any) => ind.id !== indicatorId
            ),
          };
        }
        return group;
      });
      return { ...prevState, groups: updatedGroups };
    });
  };



  const validateForm = () => {
    let formIsValid = true;

    let newErrors: any = {
      role_name: "",
      selectedRole: "",
      groups: "",
      status: "",
    };

    if (!formData.role_name.trim()) {
      formIsValid = false;
      newErrors.role_name = "Role name is required.";
    }

    if (!formData.selectedRole || formData.selectedRole.value === "Select") {
      formIsValid = false;
      newErrors.selectedRole = "Role selection is required.";
    }

    if (!formData.groups || formData.groups.length === 0) {
      formIsValid = false;
      newErrors.groups = "At least one group is required.";
    }

    if (!formData.status || formData.status.value === "Select") {
      formIsValid = false;
      newErrors.status = "Status is required.";
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) return;

    if (
      !formData.role_name ||
      formData.selectedRole === "Select" ||
      formData.status === "Select"
    ) {
      alert("Please fill out Role Name, Role, and Status.");
      return;
    }

    if (!formData.groups || formData.groups.length === 0) {
      alert("Please add at least one group before submitting.");
      return;
    }

    for (const group of formData.groups) {
      if (!group.selectedGroup) {
        alert("Please select an Indicator Group.");
        return;
      }

      const groupWeightage = parseInt(group.weightage);
      if (!group.weightage || isNaN(groupWeightage)) {
        alert("Please provide a valid weightage for each group.");
        return;
      }

      if (groupWeightage > 101) {
        alert(
          `Group ${group.selectedGroup.label} weightage should be a maximum of 3 digits (<= 100).`
        );
        return;
      }

      let kraWeightageSum = 0;

      for (const indicator of group.indicators) {
        if (!indicator.kra) {
          alert("Please select a KRA for each indicator row.");
          return;
        }
        if (!indicator.indicator) {
          alert("Please select an Indicator.");
          return;
        }

        const kraWeightage = parseInt(indicator.weightage);
        if (!indicator.weightage || isNaN(kraWeightage)) {
          alert("Please provide a valid Weightage for each indicator row.");
          return;
        }
        kraWeightageSum += kraWeightage;

        if (!indicator.rating || isNaN(indicator.rating)) {
          alert("Please give an Expected Rating.");
          return;
        }
      }

      if (kraWeightageSum > groupWeightage) {
        alert(
          `Total weightage of KRAs in group "${group.selectedGroup.label}" exceeds group weightage (${groupWeightage}).`
        );
        return;
      }
    }

    for (const group of formData.groups) {
      if (!group.selectedGroup) {
        alert("Please select an Indicator Group.");
        return;
      }
      if (!group.weightage || isNaN(group.weightage)) {
        alert("Please provide a valid weightage for each group.");
        return;
      }

      for (const indicator of group.indicators) {
        if (!indicator.kra) {
          alert("Please select a KRA for each indicator row.");
          return;
        }
        if (!indicator.indicator) {
          alert("Please select an Indicator.");
          return;
        }
        if (!indicator.weightage || isNaN(indicator.weightage)) {
          alert("Please provide a valid Weightage for each indicator row.");
          return;
        }
        if (!indicator.rating || isNaN(indicator.rating)) {
          alert("Please give an Expected Rating.");
          return;
        }
      }
    }

    dispatch(createRoleIndicator(formData))
      .then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success(res.payload.message);
          setFormData({
            role_name: "",
            selectedRole: formattedDegination[0] || {
              value: "Select",
              label: "Select",
            },
            groups: [],
            status: status[0],
          });
          dispatch(fetchAllRoleindicator())
          onClose();
        } else {
          message.success(res.payload.message);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };

  return (
    <>
      <Drawer
        title="Add Role Indicator"
        placement="right"
        onClose={onClose}
        open={open}
        width={600}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form onSubmit={handleSubmit}>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Name <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="role_name"
                    value={formData.role_name}
                    placeholder="Enter Name"
                    onChange={(e) =>
                      setFormData({ ...formData, role_name: e.target.value })
                    }
                  />
                  {errors.role_name && (
                    <div style={{ color: "red" }}>{errors.role_name}</div>
                  )}
                </div>
              </div>
              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label">
                    Role <span className="text-danger"> *</span>
                  </label>
                  <Select
                    options={formattedDegination.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                    value={formData.selectedRole.value}
                    onChange={handleRoleChange}
                  />
                  {errors.selectedRole && (
                    <div className="text-danger mt-1">{errors.selectedRole}</div>
                  )}
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3 d-flex justify-content-between align-items-center">
                  <label className="fw-medium">
                    Add Group <span className="text-danger"> *</span>
                  </label>
                  <button
                    type="button"
                    className="btn btn-success btn-sm"
                    onClick={handleAddGroup}
                  >
                    +
                  </button>
                  {errors.groups && (
                    <div className="text-danger mb-2">{errors.groups}</div>
                  )}
                </div>
              </div>
              {formData.groups.map((group: any, groupIndex: number) => (
                <div key={group.id} className="col-md-12">
                  <div className="p-3 mb-4 border rounded bg-light">
                    <h5 className="fw-bold text-primary">
                      Indicator Group {groupIndex + 1}:{" "}
                      {group.selectedGroup ? group.selectedGroup.label : ""}{" "}
                      <span className="text-danger"> *</span>
                    </h5>
                    <div className="d-flex gap-3 align-items-center">
                      <Select
                        styles={{
                          container: (base: any) => ({
                            ...base,
                            width: "50%",
                          }),
                        }}
                        options={formattedIndicatorGroup}
                        value={group.selectedGroup}
                        onChange={(e: any) => handleGroupChange(e, group.id)}
                      />
                      <input
                        className="form-control w-50"
                        type="number"
                        placeholder="Weightage"
                        value={group.weightage || ""}
                        onChange={(e) => handleWeightageChange(e, group.id)}
                      />
                    </div>

                    {group.selectedGroup && (
                      <div className="table-responsive">
                        <table className="table table-bordered mt-3">
                          <thead>
                            <tr>
                              <th>S. No</th>
                              <th>
                                KRA <span className="text-danger"> *</span>
                              </th>
                              <th>
                                Indicators{" "}
                                <span className="text-danger"> *</span>
                              </th>
                              <th>
                                Weightage{" "}
                                <span className="text-danger"> *</span>
                              </th>
                              <th>
                                Expected-Rating{" "}
                                <span className="text-danger"> *</span>
                              </th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {group.indicators.length === 0 &&
                              handleAddIndicatorRow(group.id)}

                            {group.indicators
                              .filter(
                                (indicator: any) =>
                                  indicator.kraId === group.selectedKRA
                              )
                              .map((kraIndicator: any, index: number) => (
                                <tr key={kraIndicator.id}>
                                  <td>{index + 1}</td>

                                  <td>
                                    <Select
                                      options={formattedKRA}
                                      name="kra"
                                      value={
                                        formattedKRA.find(
                                          (opt: any) =>
                                            opt.value === kraIndicator.kra
                                        ) || null
                                      }
                                      onChange={(selectedOption: any) => {
                                        console.log(
                                          "Selected KRA:",
                                          selectedOption
                                        );
                                        handleInputChange(
                                          selectedOption,
                                          group.id,
                                          index,
                                          true,
                                          "kra"
                                        );
                                      }}

                                    />
                                  </td>
                                  <Select
                                    options={formattedindicator}
                                    name="indicator"
                                    value={
                                      formattedindicator.find(
                                        (opt: any) =>
                                          opt.value === kraIndicator.indicator
                                      ) || null
                                    }
                                    onChange={(SelectedOption: any) => {
                                      handleInputChange(
                                        SelectedOption,
                                        group.id,
                                        index,
                                        true,
                                        "indicator"
                                      );
                                    }}
                                  />

                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="weightage"
                                      value={kraIndicator.weightage || ""}
                                      onChange={(e) =>
                                        handleInputChange(e, group.id, index)
                                      }
                                    />
                                  </td>

                                  <td>
                                    <StarRating
                                      rating={kraIndicator.rating || 0}
                                      onRate={(newRating) =>
                                        handleRatingChange(
                                          newRating,
                                          group.id,
                                          index
                                        )
                                      }
                                    />
                                  </td>

                                  <td>
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm me-2"
                                      onClick={() =>
                                        handleRemoveIndicatorRow(
                                          group.id,
                                          kraIndicator.id
                                        )
                                      }
                                    >
                                      -
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm me-2"
                                      onClick={() =>
                                        handleAddIndicatorRow(group.id)
                                      }
                                    >
                                      +
                                    </button>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                  <div className="modal-body">
                    <div className=" d-flex justify-content-end gap-3 mt-3">
                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={handleAddGroup}
                      >
                        +
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={handleRemoveGroup}
                      >
                        -
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="col-md-12">
              <div className="mb-3">
                <label className="form-label">
                  Status <span className="text-danger"> *</span>
                </label>
                <Select
                  options={status}
                  value={formData.status.value}
                  onChange={handleStatusChange}
                />
              </div>
              {errors.status && (
                <div className="text-danger mt-1">{errors.status}</div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-light me-2" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              {isLoading && (<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />)}
              Add Indicator
            </button>
          </div>

        </form>
      </Drawer>
    </>
  );
};

export default PerformanceIndicatorModal;
